import { Box, Container, Flex, Text } from "flicket-ui";
import { Footer, ContentContainer, Status } from "~components";
import React from "react";
import styled from "styled-components";
import { EventCard } from "./events.Card";
import { EventsQuery, PointItem } from "~graphql/sdk";
import { CollapsibleSearch } from "./events.CollapsibleSearch";

export type SearchableEvent = EventsQuery["events"]["edges"][number]["node"];

export type PointItemDisplay = Partial<PointItem> & {
  id: string;
  amount?: number;
  price?: number;
  name?: string;
};

export interface ListProps {
  isLoading: boolean;
  error: Error | null;
  events: SearchableEvent[];
  setSearch: (search: string) => void;
  // featuredEvents: Partial<Event>[];
  // pointItems?: PointItemDisplay[];
  // pointName?: string;
}

const EventsContainer = styled(Box)`
  max-width: 100%;
  margin: 0 auto;
  padding: 0;
`;

/**
 * Events List component displaying a list of events
 *
 * @component
 * @param props - Component props
 * @param props.isLoading - Whether the list is loading
 * @param props.error - Any error that occurred during loading
 * @param props.events - Array of events to display
 * @param props.setSearch - Callback for search input changes
 */

export const List: React.FC<ListProps> = ({
  isLoading,
  setSearch,
  events,
  error,
  // featuredEvents,
  // pointItems,
  // pointName,
}) => {
  return (
    <ContentContainer variant="content">
      <Flex flexDir="column" flex="1">
        <Flex
          justifyContent="space-between"
          alignItems="center"
          width="100%"
          maxWidth="1248px"
          display={{ _: "none", md: "block" }}
        />

        <Container
          mb={6}
          innerProps={{
            borderRadius: { md: "md" },
            maxWidth: { _: "600px", sm: "880px", md: "100vw" },
            margin: "auto !important" as any,
          }}
        >
          {/* {!!featuredEvents?.length && (
            <>
              <Text
                variant="header.S"
                fontSize={3}
                lineHeight="normal"
                fontWeight="bold"
                color="N800"
                display={{ _: "block", md: "none" }}
                px={{ _: 3, md: 4 }}
              >
                Featured events
              </Text>
              <Divider mt={1} mb={2} display={{ _: "block", md: "none" }} />
              <FeaturedEvents
                events={featuredEvents.map(
                  (event) =>
                    ({
                      id: event.id,
                      title: event.title,
                      venue: event.venue,
                      startDate: event.startDate,
                      endDate: event.endDate,
                      thumbnail: event.thumbnail,
                      backgroundImage: event.backgroundImage,
                    } as Partial<Event>)
                )}
              />
            </>
          )} */}

          <Flex
            justifyContent="space-between"
            alignItems="center"
            width="100%"
            flexDirection="row"
          >
            <Text variant="header.L" lineHeight="normal">
              Events
            </Text>
            <Box
              flex="1"
              maxWidth={{ _: "50%", md: "300px" }}
              display="flex"
              justifyContent="flex-end"
            >
              <CollapsibleSearch
                onChange={(value: string) => setSearch(value?.trim())}
                placeholder="Search events..."
                initialState={{ status: "collapsed" }}
                containerWidth={{
                  collapsed: "40px",
                  expanded: "300px",
                }}
              />
            </Box>
          </Flex>

          <EventsContainer>
            <Status
              noResultText="No upcoming events, check back soon!"
              loading={isLoading}
              error={error}
            >
              {events?.length === 0 ? (
                <Box px={3} py={4} textAlign="center">
                  <Text variant="regular">No events found.</Text>
                </Box>
              ) : (
                <Box width="100%" className="event-list-container" pt={2}>
                  {events?.map((event) => (
                    <EventCard
                      key={event.id}
                      id={event.id}
                      title={event.title}
                      venue={event.venue}
                      startDate={event.startDate}
                      endDate={event.endDate}
                      eventKind={event.eventKind}
                      hasPublicRelease={event.hasPublicRelease ?? false}
                      thumbnail={event.thumbnail}
                      logo={event.logo}
                      descriptionImage={event.descriptionImage}
                    />
                  ))}
                </Box>
              )}
            </Status>
          </EventsContainer>
        </Container>
      </Flex>
      <Footer />
    </ContentContainer>
  );
};
